import React from 'react'
import { View, Text, StyleSheet } from 'react-native'

const FallbackImageUpload = ({ style, ...props }) => (
  <View style={[styles.container, style]}>
    <Text style={styles.text}>
      Image picker functionality requires @protonapp/runner-imagepicker package
    </Text>
  </View>
)

const styles = StyleSheet.create({
  container: {
    padding: 10,
    backgroundColor: '#f8f9fa',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#dee2e6',
  },
  text: {
    color: '#6c757d',
    textAlign: 'center',
  },
})

export default FallbackImageUpload
